import ChevronIcon from "@icons/chevronIcon.svg";
import styles from "./qiFilterMenu.module.scss";
import { QuestionIndexing } from "@kunduz/data-access-qi-api";
import { Fragment } from "react";
import classNames from "classnames";
import { Collapse } from "@kunduz/ui";
import { getQIUrl } from "@kunduz/utility-common";

export const QIFilterMenu = (props: Props) => {
  const LinkComponent = props.linkAs ?? "a";

  const changeItemPositionFromAnArray = (arr: any[]) => {
    const activeIndex = props.courses.findIndex(
      (c) => c.slug === props.activeCourseSlug,
    );
    const fromIndex = activeIndex;
    const toIndex = 0;

    const element = arr.splice(fromIndex, 1)[0];
    arr.splice(toIndex, 0, element);

    return arr;
  };

  const renderContentNode = (slug: string) =>
    props.subjects
      ?.filter((s) => s.has_question_seo)
      .map((subject) => (
        <LinkComponent
          className={classNames(
            styles["subjectLink"],
            props.activeSubjectSlug === subject.slug && styles["active"],
          )}
          href={getQIUrl({
            lang: props.lang,
            courseSlug: slug,
            subjectSlug: subject.slug,
          })}
          key={subject.id}
        >
          {subject.name}
        </LinkComponent>
      ));

  const renderTriggerNode = (slug: string, name: string) => (
    <div
      className={classNames(
        styles["item"],
        styles["triggerNodeContainer"],
        props.activeCourseSlug === slug && styles["active"],
      )}
    >
      <div className={styles["courseLink"]}>
        <span>{name}</span>
        <ChevronIcon />
      </div>
    </div>
  );

  const renderCoursesAndSubjects = () => (
    <section id="qi-filter-menu" className={styles["container"]}>
      <LinkComponent
        href={getQIUrl({ lang: props.lang })}
        className={styles["backTitle"]}
      >
        {props.subjectAndCoursesTitle}
      </LinkComponent>
      {changeItemPositionFromAnArray(props.courses).map(
        (course: QuestionIndexing.IQiCourse, index) => (
          <Fragment key={course.id}>
            {index !== 0 && (
              <div
                className={classNames(
                  styles["item"],
                  props.activeCourseSlug === course.slug && styles["active"],
                )}
              >
                <LinkComponent
                  className={styles["courseLink"]}
                  href={getQIUrl({ lang: props.lang, courseSlug: course.slug })}
                >
                  <span>{course.name}</span>
                  <ChevronIcon />
                </LinkComponent>
              </div>
            )}
            {props.activeCourseSlug === course.slug && (
              <Collapse
                defaultOpen
                contentNode={renderContentNode(course.slug)}
                triggerNode={renderTriggerNode(course.slug, course.name)}
              />
            )}
          </Fragment>
        ),
      )}
    </section>
  );

  const renderJustCourses = () => (
    <section id="qi-filter-menu" className={styles["container"]}>
      <div className={styles["title"]}>{props.coursesTitle}</div>
      {props.courses.map((course) => (
        <div key={course.id} className={styles["item"]}>
          <LinkComponent
            className={styles["courseLink"]}
            href={getQIUrl({ lang: props.lang, courseSlug: course.slug })}
          >
            <span>{course.name}</span>
            <ChevronIcon />
          </LinkComponent>
        </div>
      ))}
    </section>
  );

  if (props.courses && props.subjects) {
    return renderCoursesAndSubjects();
  }

  if (props.courses) {
    return renderJustCourses();
  }

  return <></>;
};

interface Props {
  courses: QuestionIndexing.IQiCourse[];
  coursesTitle?: string;
  subjectAndCoursesTitle?: string;
  subjects?: QuestionIndexing.IQiSubject[];
  activeCourseSlug?: string;
  activeSubjectSlug?: string;
  lang: "tr" | "en";
  linkAs?: React.ElementType;
}
